import {useEffect, useState} from 'react'

import {useUserConsents} from '@s-ui/consents'
import {useSuiContext} from '@s-ui/react-context'

export const useLastAdsSearches = () => {
  const {domain} = useSuiContext()
  const config = domain.get('config')

  const {
    CONSENTS: {LAST_ADS_SEARCH: lastAdsSearchRequiredConsents}
  } = config.get('COMMON')

  const hasConsentsForLastAdsSearch = useUserConsents(lastAdsSearchRequiredConsents)

  const [isLastAdsSearchesModalOpen, setLastAdsSearchesModalOpen] = useState(false)
  const [lastAdsSearches, setLastAdsSearches] = useState([])

  const _getLastSearches = () => {
    domain
      .get('get_last_searches_ads_use_case')
      .execute()
      .then(({items}) => setLastAdsSearches(items))
  }

  const onOpenLastAdsSearchesModal = () => {
    _getLastSearches()
    setLastAdsSearchesModalOpen(true)
  }

  const onCloseLastAdsSearchesModal = () => {
    setLastAdsSearchesModalOpen(false)
  }

  useEffect(() => {
    if (hasConsentsForLastAdsSearch) {
      const getSaveLastAdsSearchUseCase$ = domain
        .get('save_last_ads_search_use_case')
        .$.execute.subscribe(_getLastSearches)

      _getLastSearches()

      return () => {
        getSaveLastAdsSearchUseCase$.dispose()
      }
    }
  }, [hasConsentsForLastAdsSearch]) // eslint-disable-line

  return {
    lastAdsSearches,
    isLastAdsSearchesModalOpen,
    onCloseLastAdsSearchesModal,
    onOpenLastAdsSearchesModal
  }
}
